module.exports = __webpack_public_path__ + "6fb621f9b8bcc014a8e408ede35592eb.pdf";